import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererParams } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { BaseCellRendererComponent } from '../base-cell-renderer/base-cell-renderer.component';

@Component({
    selector: 'medpace-custom-cell-render-img',
    standalone: true,
    templateUrl: './custom-cell-render-img.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellRenderImgComponent<TContext = any> extends BaseCellRendererComponent<
    StudyExpenseTrackingDataRow,
    string,
    TContext,
    { src: string }
> {
    refresh(
        params: ICellRendererParams<StudyExpenseTrackingDataRow, string, TContext> & {
            src: string;
        }
    ): boolean {
        this.baseParams.set(params);
        this.customParams.set(params);
        return true;
    }
}
